import { BeBox, BeCol, BeCols, BePage, BeStack } from "@beos-css/react/index.ts";

function Cell({ span }: { span: number }) {
	return (
		<BeCol span={span}>
			<BeBox border="plain">span {span}</BeBox>
		</BeCol>
	);
}

export function ColumnGridDemo() {
	return (
		<section id="demo-page-cols">
			<h2>Column grid (BeCols / BeCol)</h2>
			<p>
				Sixteen columns above 672px of <em>container</em> width, one below — so <code>span</code> is a plain number that always means the
				same fraction. Narrow the window: every row stacks at the same point, and no call site names a breakpoint. The container snaps to a
				whole page unit, which is what keeps a track integral at every width.
			</p>
			{/* Required: .be-cols counts against the nearest `be-page` container and degrades to a stack without one. */}
			<BePage className="be-panel" pad={1}>
				<BeStack gap="section">
					<BeCols>
						{Array.from({ length: 16 }, (_, i) => i + 1).map((n) => (
							<BeCol key={n} span={1}>
								<BeBox border="plain">{n}</BeBox>
							</BeCol>
						))}
					</BeCols>
					<BeCols>
						<Cell span={2} />
						<Cell span={2} />
						<Cell span={2} />
						<Cell span={2} />
						<Cell span={2} />
						<Cell span={2} />
						<Cell span={2} />
						<Cell span={2} />
					</BeCols>
					<BeCols>
						<Cell span={5} />
						<Cell span={3} />
						<Cell span={7} />
						<Cell span={1} />
					</BeCols>
					<BeCols>
						<Cell span={6} />
						<Cell span={10} />
					</BeCols>
					<BeCols>
						<Cell span={9} />
						<Cell span={7} />
					</BeCols>
					<BeCols>
						<Cell span={11} />
						<Cell span={5} />
					</BeCols>
					<BeCols>
						<Cell span={13} />
						<Cell span={3} />
					</BeCols>
					<BeCols>
						<Cell span={14} />
						<Cell span={2} />
					</BeCols>
					<BeCols>
						<Cell span={15} />
						<Cell span={1} />
					</BeCols>
					{/* Short rows on purpose: a span is a width, so the remainder stays empty. */}
					<BeCols>
						<Cell span={4} />
					</BeCols>
					<BeCols>
						<Cell span={3} />
						<Cell span={5} />
					</BeCols>
					<BeCols>
						<Cell span={6} />
						<Cell span={6} />
					</BeCols>
					{/* Over 16 on purpose: the 8 wraps, which is what a mistyped span looks like. */}
					<BeCols>
						<Cell span={12} />
						<Cell span={8} />
					</BeCols>
					<BeCols>
						<Cell span={8} />
						<Cell span={8} />
					</BeCols>
					<BeCols>
						<Cell span={4} />
						<Cell span={4} />
						<Cell span={4} />
						<Cell span={4} />
					</BeCols>
					<BeCols>
						<Cell span={12} />
						<Cell span={4} />
					</BeCols>
					{/* A cell is a containment context, so the nested grid measures the cell, not the page. */}
					<BeCols>
						<BeCol span={8}>
							<BeBox border="plain">
								<BeCols>
									<Cell span={8} />
									<Cell span={8} />
								</BeCols>
							</BeBox>
						</BeCol>
						<Cell span={8} />
					</BeCols>
				</BeStack>
			</BePage>
		</section>
	);
}
